export default "__VITE_ASSET__C1Zmx9rb__"